
let swiper6 = new Swiper('#swiper_works', {  //スライダーのコンテナ要素の id で初期化
   // デフォルトの設定
  slidesPerView: 1,
  spaceBetween: 30,
  loopFillGroupWithBlank: true,
  loop: true,
  // レスポンシブブレーポイント（画面幅による設定）
  breakpoints: {

    640: {
      slidesPerView: 1,
      spaceBetween: 40
    }
  },

  navigation: {  //ナビゲーションボタンを表示
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});


let swiper7 = new Swiper('#swiper_thebestevent', {  //スライダーのコンテナ要素の id で初期化
  // デフォルトの設定
 slidesPerView: 1,
 spaceBetween: 30,
 loopFillGroupWithBlank: true,
 loop: true,
 // レスポンシブブレーポイント（画面幅による設定）
 breakpoints: {

   640: {
     slidesPerView: 1,
     spaceBetween: 40
   }
 },

 navigation: {  //ナビゲーションボタンを表示
   nextEl: '.swiper-button-next',
   prevEl: '.swiper-button-prev',
 },
});
